import axios from "axios";
import { IUser } from "../Types/user";

export const completeEnterpriseSSOLogin = (
  code: string,
  state: string | null,
  callback: (user: IUser) => void,
  errorCallback: (error: any) => void
) => {
  const URL = `${import.meta.env.VITE_API_BASE_URL}/auth/oidc/complete`;

  // Build query string
  const params = new URLSearchParams();
  params.append('code', code);
  if (state) {
    params.append('state', state);
  }

  const completeURL = `${URL}?${params.toString()}`;

  return axios.get(completeURL, {
    // Explicitly disable credentials; backend does not use cookie-based sessions for this flow
    withCredentials: false,
  })
    .then((response) => {
      if (callback) {
        callback(response.data as IUser);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};

